import reformatSchedules from './reformat-schedules';

// Mirrors the backend contract (ShootingSchedule#available_timeslots): each block's
// `numAvailable` is the block's FREE CAPACITY in minutes = appointment_interval *
// free_photographers — it is NOT the whole sitting length. A sitting longer than one
// interval just occupies multiple consecutive blocks (handled by blocksPerAppointment).
//
// Regression for the Beyer HS senior-scheduling bug: super/deluxe sittings (whose
// appointmentValue is longer than one interval) showed "no times available" while
// basic/economy showed times, because the per-block capacity was compared against the
// full sitting duration.

const SCHOOL_ID = 695;
const INTERVAL = 5; // school appointment_interval (minutes per block)

// A single shooting day with three 5-minute blocks, one photographer free in each
// (numAvailable = interval * 1 = 5).
const schedules = [
  {
    schoolId: SCHOOL_ID,
    shootingDay: '2026-09-01',
    availableTimeslots: [
      { time: '9:00 AM', numAvailable: INTERVAL },
      { time: '9:05 AM', numAvailable: INTERVAL },
      { time: '9:10 AM', numAvailable: INTERVAL },
      { time: '9:15 AM', numAvailable: INTERVAL },
    ],
  },
];

describe('reformatSchedules', () => {
  it('returns {} until the school interval is known', () => {
    expect(reformatSchedules(schedules, 5, SCHOOL_ID, undefined)).toEqual({});
  });

  it('shows times for a basic/economy sitting (one block long)', () => {
    const result = reformatSchedules(schedules, INTERVAL, SCHOOL_ID, INTERVAL);

    expect(result['2026-09-01'].length).toBeGreaterThan(0);
  });

  it('shows times for a super/deluxe sitting longer than one interval (the bug)', () => {
    // Super sitting = 20 minutes. Previously `numAvailable (5) >= minValue (20)`
    // filtered out every block, so the customer saw no availability on an empty day.
    const superSittingValue = 20;

    const result = reformatSchedules(schedules, superSittingValue, SCHOOL_ID, INTERVAL);

    expect(result['2026-09-01'].length).toBeGreaterThan(0);
  });

  it('spaces a 20-minute sitting one start per blocksPerAppointment (every 4 blocks)', () => {
    // 20-min sitting / 5-min interval => 4 blocks per appointment. With 4 free blocks
    // that yields exactly one offered start time.
    const result = reformatSchedules(schedules, 20, SCHOOL_ID, INTERVAL);

    expect(result['2026-09-01']).toEqual([{ time: '9:00 AM', numAvailable: INTERVAL }]);
  });

  it('drops blocks with no free capacity (numAvailable below one interval)', () => {
    const withFullBlock = [
      {
        schoolId: SCHOOL_ID,
        shootingDay: '2026-09-01',
        availableTimeslots: [
          { time: '9:00 AM', numAvailable: 0 }, // fully booked
          { time: '9:05 AM', numAvailable: INTERVAL },
        ],
      },
    ];

    const result = reformatSchedules(withFullBlock, INTERVAL, SCHOOL_ID, INTERVAL);

    expect(result['2026-09-01'].map((t) => t.time)).not.toContain('9:00 AM');
    expect(result['2026-09-01'].map((t) => t.time)).toContain('9:05 AM');
  });
});
